import { inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

/** Домен и есть имя заведения: организацию бэкенд определяет по нему же, отдельного названия у нас нет. */
function siteName(fallback: () => string): string {
  try {
    const host = location.hostname.replace(/^www\./i, '');
    return host.length > 0 ? host : fallback();
  } catch {
    // Нет window (SSR, тесты) — заголовок всё равно обязан быть.
    return fallback();
  }
}

/** «{домен} — {страница}»: один заголовок на всех экранах нарушает WCAG 2.4.2 Page Titled. */
@Injectable({ providedIn: 'root' })
export class AppTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);
  private readonly translate = inject(TranslateService);

  /** Последний снапшот — чтобы перевести заголовок заново при смене языка без навигации. */
  private lastSnapshot: RouterStateSnapshot | null = null;

  constructor() {
    super();
    this.translate.onLangChange.pipe(takeUntilDestroyed()).subscribe(() => {
      if (this.lastSnapshot !== null) {
        this.updateTitle(this.lastSnapshot);
      }
    });
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    this.lastSnapshot = snapshot;
    const key = this.buildTitle(snapshot);
    const page = key ? String(this.translate.instant(key)) : '';
    const site = siteName(() => String(this.translate.instant('APP_TITLE')));
    this.title.setTitle(page ? `${site} — ${page}` : site);
  }
}
